import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {CardGrid} from '../CardGrid'

import './artists.css'

const nArtistsPerRow = 4;

class ArtistGrid extends Component {

  render () {
    let data = this.props.data;

    return (
      <div>
        <Title name={data.title}></Title>
        <CardGrid
          nCellsPerRow = {nArtistsPerRow}
          data = {data.artists}
          sizes = {this.props.sizes}
          isShort = {this.props.isShort}
        ></CardGrid>
      </div>
    );
  }
}


export default {ArtistGrid}



// WEBPACK FOOTER //
// ./src/components/ArtistGrid/index.js